import React from 'react';
import { useState,useEffect } from 'react';
import '../core.scss'
import './PilgrimServicesStyle.scss';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
}
from 'mdb-react-ui-kit';
import axios from 'axios';
import {  toast } from 'react-toastify';
import { baseApiCore } from '../Constants';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
 function PilgrimServices() {
  const [justifyActive, setJustifyActive] = useState('RegistrationOfServants');
  const { register, formState: { errors },watch, handleSubmit } = useForm();
  const token=Cookies.get('auth');
  const nav = useNavigate();
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
  
  const RegistrationOfServants = data =>{
    document.body.classList.add('loading-Authentication');
    axios.post(`${baseApiCore}ServantRequests`, data)
    .then(response =>{
      document.body.classList.remove('loading-Authentication');
      toast.success(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        })
        nav("*u")
      }
    )
    .catch(error => {
      document.body.classList.remove('loading-Authentication');
      toast.error(error.response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        });
   });
  }
  return (
<div className='Authentication col-12 col-md-12 d-flex '>
<div className='Authentication-container col-10 col-md-6'>


<div className='Authentication-box'>
<MDBContainer className=" my-5 d-flex flex-column w-90 col-md-7">
<MDBTabs pills justify className='d-flex flex-row justify-content-between mt-3'>
    <MDBTabsLink active={justifyActive === 'RegistrationOfServants'}>
ثبت نام خادمین 
    </MDBTabsLink>
 
</MDBTabs>

<MDBTabsContent>

  <MDBTabsPane show={justifyActive === 'RegistrationOfServants'}>

<form onSubmit={handleSubmit(RegistrationOfServants)} className='khorshidPishva-form' style={{marginBottom: "50%",marginTop: "10%"}}>
      <div className="mb-3 d-column">
        <label  className="form-label">آدرس:</label>
        <input className='form-control' type="text" placeholder="آدرس" {...register("Address", {
        required: "این فیلد الزامی میبشد",
        maxLength: 30,
        pattern: {
          value: /^[\u0600-\u06FF\s]+$/,
          message: "لطفا آدرس معتبر  وارد نمایید",
        },
        })} />
        <ErrorMessage errors={errors}
         name="FirstName"
         render={({ message }) => <span className='erore-massage'>{message}</span>}
         />
      </div>

    <div className="mb-3 d-column">
        <label  className="form-label"> شغل:</label>
        <input className='form-control' type="text" placeholder="شغل" {...register("Job", {
          required: "این فیلد الزامی میبشد",
          maxLength: 30,
          pattern: {
            value: /^[\u0600-\u06FF\s]+$/,
            message: "لطفا شغل  خود فارسی  وارد نمایید",
          },
          })} />
        <ErrorMessage errors={errors}
         name="LastName"
         render={({ message }) => <span className='erore-massage'>{message}</span>}
         />
      </div>
      
      {/* <div className="mb-3 d-column">
        <label  className="form-label">کدملی:</label>
        <input className='form-control' type="text" placeholder="کدملی" {...register("nationalId", {
          required: "این فیلد الزامی میبشد",
          maxLength:10,
          pattern: {
            value: /^[0-9]*$/,
            message: "فرمت کدملی اشتباه میباشد",
          },
          })} />
        <ErrorMessage errors={errors}
         name="nationalId"
         render={({ message }) => <span className='erore-massage'>{message}</span>}
         />
      </div> */}

          <input type="submit" value='ارسال' className='submit'/>
      </form>
  </MDBTabsPane>

</MDBTabsContent>

</MDBContainer>
</div>


</div>
</div>
  )
}
export default PilgrimServices;